export enum RangeDirection {
    Forward,
    Backward,
}
